
import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function AboutUsPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-24 px-6 lg:px-12 bg-[#FAFAF9]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-8">
            We make diabetic eye screening <span className="text-[#093a3e] italic font-serif">easy to deliver&nbsp;</span>and <span className="text-[#093a3e] italic font-serif">easy to measure.</span>
          </h1>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-24 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#093a3e]/20 rounded-full mb-6">
            <i className="ri-heart-pulse-line text-[#093a3e] text-3xl"></i>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Our Mission</h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Kinra Health exists to prevent avoidable vision loss by making diabetic retinopathy screening accessible in the places patients already receive care.
          </p>
        </div>
      </section>

      {/* What Makes Kinra Different */}
      <section className="py-24 px-6 lg:px-12 bg-[#FAFAF9]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-16">
            What Makes Kinra Different
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Differentiator 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow text-center">
              <div className="w-12 h-12 bg-[#093a3e]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-settings-3-line text-[#093a3e] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Programmatic execution</h3>
            </div>

            {/* Differentiator 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow text-center">
              <div className="w-12 h-12 bg-[#093a3e]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-map-pin-user-line text-[#093a3e] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Access-first model</h3>
            </div>

            {/* Differentiator 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow text-center">
              <div className="w-12 h-12 bg-[#093a3e]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-line-chart-line text-[#093a3e] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Measure-aligned outcomes</h3>
            </div>

            {/* Differentiator 4 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow text-center">
              <div className="w-12 h-12 bg-[#093a3e]/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-hand-coin-line text-[#093a3e] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Aligned incentives</h3>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6 lg:px-12 bg-gray-900">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-8">
            Ready to bring accessible screening to your population?
          </h2>
          
          <p className="text-xl text-gray-300 mb-12 leading-relaxed">
            Let's talk about how Kinra can support your quality and access goals.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/contact"
              className="bg-[#093a3e] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#062b2f] hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2 group"
            >
              <span>Request a Demo</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
